import { render, staticRenderFns } from "./Createdtype.vue?vue&type=template&id=ba22f216&scoped=true"
import script from "./Createdtype.vue?vue&type=script&lang=js"
export * from "./Createdtype.vue?vue&type=script&lang=js"
import style0 from "./Createdtype.vue?vue&type=style&index=0&id=ba22f216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba22f216",
  null
  
)

export default component.exports